import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Total Sales: ")
const _hoisted_3 = { class: "chart" }
const _hoisted_4 = { class: "total-product" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-wallet",
  style: {"font-size":"100px"}
}, null, -1)
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", null, "Total Products", -1)
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "total-order" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-shopping-cart-full",
  style: {"font-size":"100px"}
}, null, -1)
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h2", null, "Total Orders", -1)
const _hoisted_14 = { class: "bottom" }
const _hoisted_15 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_line_chart = _resolveComponent("line-chart")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 24 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { class: "box-card" }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("strong", null, [
                  _hoisted_2,
                  _createVNode(_component_el_tag, {
                    size: "medium",
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" $" + _toDisplayString(_ctx.totalSales), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.month,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.month = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadChart())),
                  placeholder: "Select",
                  size: "mini",
                  class: "select-month"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.replace(/\|/g, ' '),
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                (_ctx.renderComponent)
                  ? (_openBlock(), _createBlock(_component_line_chart, {
                      key: 0,
                      data: _ctx.dataChart
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        span: 8,
        style: {"display":"grid","margin-top":"20px","align-content":"stretch"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { style: {"padding":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "always" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { lg: 6 }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { lg: 18 }, {
                              default: _withCtx(() => [
                                _createVNode("div", _hoisted_6, [
                                  _hoisted_7,
                                  _createVNode("div", _hoisted_8, [
                                    _createVNode("time", _hoisted_9, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataCountProduct, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                          size: "small",
                                          type: "success",
                                          key: item
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name) + ": " + _toDisplayString(item.count) + " (Items) ", 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { style: {"padding":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "always" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_10, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { lg: 6 }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { lg: 18 }, {
                              default: _withCtx(() => [
                                _createVNode("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createVNode("div", _hoisted_14, [
                                    _createVNode("time", _hoisted_15, _toDisplayString(_ctx.totalOrder), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}